<template>
    <v-col cols="12" class="MyReports mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                <v-row >
                        <v-col>
                            <h2 class="font-weight-medium text-center title-reports my-6">Mis Reportes</h2>
                        </v-col>
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#7F03BB"
                                    to="/system/reports/payment"
                            >
                                <v-icon>mdi-cart</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#FFB12A"
                                    @click="dialog.video = true"
                            >
                                <v-icon>mdi-play</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#0172C0"
                            >
                                <v-icon>mdi-flash</v-icon>
                        </v-btn>  
                </v-row>


                    <v-row
                        class="pa-4 pt-0"
                    >
                        <v-col 
                            v-for="(categoria,icat) in ['Educacional','Supermercados','Edificios','Mineria']"
                                            :key="icat"
                        cols="12" class="px-0 pt-0">
                                <h3 class="ml-6 title-category">{{categoria}}</h3>
                                <v-slide-group show-arrows>
                                    <v-slide-item
                                        v-for="(item,i) in 12"
                                        :key="i+'-c-1'"
                                    >
                                        <v-col>
                                            <v-card
                                                width="300"
                                                height="250"
                                                class="elevation-0 text-center card-reports d-flex align-center justify-center"
                                                >
                                                <div class="">
                                                    <h4 >Análisis de Desempeño de<br> Plantas</h4> 
                                                    <p >
                                                    Lorem Ipsum is simply dummy text <br> of the printing and typesetting<br> industry. Lorem Ipsum has been the <br>industry's standard dummy.
                                                    </p>
                                                    <v-btn
                                                        class="btn-report-2"
                                                        to="/system/reports/report-detail"
                                                        >
                                                        Descargas 1/10
                                                    </v-btn>
                                                </div>
                                            </v-card>
                                        </v-col>
                                    </v-slide-item>
                                </v-slide-group>
                        </v-col>
                    </v-row>

                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
    export default {
        name: 'MyReports',
        created: function () {
            this.$emit('SetcolorMenu', '#7F03BB');
        }
    }
</script>